import { ConnectedHTMLElement } from "./ConnectedHtmlElement.js";
import { DispatchAction, RegisterActionListener } from "../state/State.js";
import { GameActions } from "../state/GameReducer.js";

/**
 * @name BaseInitiative
 * @class BaseInitiative
 * @extends {ConnectedHTMLElement}
 * @description
 *
 */
export class BaseInitiative extends ConnectedHTMLElement {
  static observedAttributes = ["player"];
  constructor() {
    super();
    this.registerActionListeners();
  }

  /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */
  stateUpdated(newState, oldState) {
    const player = this.getAttribute("player");
    if (
      //newState[player].hasInitiative !== oldState[player].hasInitiative ||
      (oldState.currentGame === undefined &&
        newState.currentGame !== undefined) ||
      (newState.currentGame !== undefined &&
        newState.currentGame?.ended === true) ||
      (newState.currentGame?.ended === false &&
        oldState.currentGame?.ended === true)
    ) {
      this.render();
    }
  }

  registerActionListeners() {
    RegisterActionListener(GameActions.claimInitiative, (player) => {
      const isOpponent = player !== this.getAttribute("player");
      if (isOpponent) {
        this.renderLoseInitiative();
      } else {
        this.renderClaimInitiative();
      }
    });
  }

  registerElementEvents() {
    const player = this.getAttribute("player");
    const button = this.querySelector("button");
    button.addEventListener("click", () => {
      DispatchAction(GameActions.claimInitiative, player);
    });
  }

  renderLoseInitiative() {
    const button = this.querySelector("button");
    button.classList.remove("opacity-100");
    button.classList.add("opacity-50");
  }
  renderClaimInitiative() {
    const button = this.querySelector("button");
    button.classList.remove("opacity-50");
    button.classList.add("opacity-100");
    button.classList.add("flip");
    setTimeout(() => {
      button.classList.remove("flip");
    }, 600);
  }

  render() {
    const player = this.getAttribute("player");
    const baseSelected = this.state[player].base !== undefined;
    const tokenHidden =
      (this.state.currentGame !== undefined && this.state.currentGame.ended) ||
      this.state.currentGame === undefined;
    if (tokenHidden) {
      this.innerHTML = "";
      return;
    }
    this.innerHTML = `
          <button class="cursor-pointer left-0 bottom-12 absolute bg-transparent border-0 z-10 ${this.state[player].hasInitiative ? "opacity-100" : "opacity-50"}">
            <span class="hidden">Claim<br />Initiative</span>
            <img
              alt="Initiative counter"
              height="194"
              id="top-initiative"
              loading="lazy"
              src="/assets/img/initiative-counter.png"
              width="204"
              class="w-[90px] h-auto"
            />
          </button>
        `;
    this.registerElementEvents();
  }

  connectedCallback() {
    //this.render();
  }
}
